// extracted by mini-css-extract-plugin
module.exports = {"container":"product-image-slider_container__2QJBs","image":"product-image-slider_image__2rizX"};